export default __webpack_public_path__ + "media/images/images/gallery/4-c01ab1859b44c3c08bf533be0c09c4ff.jpg";